// import React from "react";
// import {
//   Modal,
//   Button,
//   Loader,
//   Avatar,
//   AvatarSize,
//   TextField,
//   Dropdown,
//   Iconography,
//   IconographySizes,
//   IconographyThemes,
//   LoaderSizes,
// } from "@hid-galaxy-ui/galaxy-react";

// import "./FeatureFormModal.scss";
// import { Constants } from "../../../../../utils/constants";
// import { useAppDispatch, useAppSelector } from "../../../../../redux";
// import { UserListType } from "../../../../../redux/slices/user/Types";
// import {
//   addUserSagaAction,
//   updateUserSagaAction,
// } from "../../../../../redux/saga/user/saga-actions";

// const HIDRolesOptions = Constants.HID_USER_ROLES.map((role) => ({
//   label: role,
//   value: role,
// }));

// const FeatureFormModal: React.FC<{
//   user?: UserListType[0];
//   setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
//   mode: "Add" | "Update";
// }> = ({ user, setModalOpen, mode }) => {
//   const [userDetails, setUserDetails] = React.useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     role: "",
//   });
//   const [view, setView] = React.useState<"detail" | "status">("detail");
//   const [emailStatus, setEmailStatus] = React.useState<
//     { status: "success" | "error" } | {}
//   >({});
//   const [errorMsg, setErrorMsg] = React.useState({
//     emailMsg: "",
//   });
//   const [selected, setSelected] = React.useState(null);
//   const { status } = useAppSelector((state) => state.user);
//   const dispatch = useAppDispatch();
//   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   const headerText =
//     view === "status"
//       ? ""
//       : mode === "Add"
//       ? "Add new HID user"
//       : "Update HID user";

//   React.useEffect(() => {
//     if (user) {
//       const selectedRole = HIDRolesOptions.find(
//         (role) => role.value === user.role
//       );
//       setSelected(selectedRole);
//       setUserDetails({
//         ...userDetails,
//         firstName: user.first_name,
//         lastName: user.last_name,
//         email: user.email,
//         role: user.role,
//       });
//     }
//   }, [user]);

//   React.useEffect(() => {
//     if (emailRegex.test(userDetails.email)) {
//       setEmailStatus({});
//       setErrorMsg({
//         ...errorMsg,
//         emailMsg: "",
//       });
//     }
//   }, [userDetails.email]);

//   const handleChange = (event: React.FormEvent<HTMLInputElement>): void => {
//     setUserDetails({
//       ...userDetails,
//       [event.currentTarget.name]: event.currentTarget.value,
//     });
//   };

//   const validateEmail = () => {
//     if (!emailRegex.test(userDetails.email)) {
//       setEmailStatus({ status: "error" });
//       setErrorMsg({
//         ...errorMsg,
//         emailMsg: "Enter valid email-id",
//       });
//     }
//   };

//   const onRoleSelect = (data: { label: string; value: string }) => {
//     let value = data ? data.value : "";
//     setSelected(data);
//     setUserDetails({
//       ...userDetails,
//       role: value,
//     });
//   };

//   const isAddOrUpdateButtonEnabled =
//     userDetails.firstName &&
//     userDetails.lastName &&
//     emailRegex.test(userDetails.email) &&
//     userDetails.role;

//   const addOrUpdateHIDUser = () => {
//     try {
//       // Get existing features from sessionStorage
//       const existingFeatures = sessionStorage.getItem("feature_details");
//       let features = [];

//       if (existingFeatures) {
//         try {
//           features = JSON.parse(existingFeatures);
//           if (!Array.isArray(features)) {
//             features = [];
//           }
//         } catch (error) {
//           console.error("Error parsing existing features:", error);
//           features = [];
//         }
//       }

//       if (mode === "Add") {
//         const submitData = {
//           first_name: userDetails.firstName,
//           last_name: userDetails.lastName,
//           email: userDetails.email,
//           role: userDetails.role,
//           status: "Invited",
//           address1: "",
//           city: "",
//           province: "",
//           country: "",
//           zip: "",
//         };

//         // Add to sessionStorage with unique ID
//         const newFeature = {
//           id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
//           firstName: userDetails.firstName,
//           lastName: userDetails.lastName,
//           email: userDetails.email,
//           role: userDetails.role,
//           createdDate: new Date().toISOString(),
//         };
//         features.push(newFeature);
//         sessionStorage.setItem("feature_details", JSON.stringify(features));
//         console.log("Added feature to sessionStorage:", newFeature);

//         // Dispatch Redux action
//         dispatch(addUserSagaAction(submitData));
//       } else {
//         const submitData = {
//           ID: user.ID,
//           first_name: userDetails.firstName,
//           last_name: userDetails.lastName,
//           email: user.email,
//           role: userDetails.role,
//           status: user.status,
//         };

//         // Update in sessionStorage
//         const index = features.findIndex(
//           (f: any) => f.id === user.ID || f.ID === user.ID
//         );
//         if (index !== -1) {
//           features[index] = {
//             ...features[index],
//             firstName: userDetails.firstName,
//             lastName: userDetails.lastName,
//             role: userDetails.role,
//           };
//           sessionStorage.setItem("feature_details", JSON.stringify(features));
//           console.log("Updated feature in sessionStorage:", features[index]);
//         }

//         // Dispatch Redux action
//         dispatch(updateUserSagaAction(submitData));
//       }

//       // Dispatch custom event to notify feature list
//       window.dispatchEvent(new Event("featuresUpdated"));
//       console.log("Dispatched featuresUpdated event");
//     } catch (error) {
//       console.error("Error saving feature:", error);
//     }
//   };

//   const renderView = (view: "detail" | "status") => {
//     const statusBoolean =
//       mode === "Add" ? status.addUserStatus : status.updateUserStatus;
//     const statusMessage =
//       mode === "Add" ? status.addUserMessage : "Something went wrong!";
//     switch (view) {
//       case "detail":
//         return (
//           <>
//             <div className="details-form">
//               <Avatar size={AvatarSize.XLarge} isEditable={false} />
//               <div className="input-row-wrapper">
//                 <div className="input-col-wrapper">
//                   <div className="label-field-container">
//                     <label className="field-label">
//                       First Name<span>*</span>
//                     </label>
//                     <TextField
//                       id="firstName"
//                       name="firstName"
//                       placeholder=""
//                       value={userDetails.firstName}
//                       theme="dark"
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//                 <div className="input-col-wrapper">
//                   <div className="label-field-container">
//                     <label className="field-label">
//                       Last Name<span>*</span>
//                     </label>
//                     <TextField
//                       id="lastName"
//                       name="lastName"
//                       placeholder=""
//                       value={userDetails.lastName}
//                       theme="dark"
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="input-row-wrapper">
//                 <div className="label-field-container">
//                   <label className="field-label">
//                     E-Mail ID<span>*</span>
//                   </label>
//                   <TextField
//                     {...emailStatus}
//                     helperText={errorMsg.emailMsg}
//                     id="email"
//                     name="email"
//                     placeholder=""
//                     value={userDetails.email}
//                     theme="dark"
//                     onChange={handleChange}
//                     onBlur={validateEmail}
//                     disabled={mode === "Update"}
//                   />
//                 </div>
//               </div>
//               <div className="input-row-wrapper">
//                 <div className="label-field-container">
//                   <label className="field-label">
//                     Role<span>*</span>
//                   </label>
//                   <Dropdown
//                     id="role"
//                     name="role"
//                     placeholder="Select Role to Assign"
//                     options={HIDRolesOptions}
//                     theme="dark"
//                     selected={selected}
//                     onSelect={onRoleSelect}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="button-group">
//               <Button
//                 variant="secondary"
//                 label="Cancel"
//                 onClick={() => setModalOpen(false)}
//               />
//               <Button
//                 variant="primary"
//                 label={mode === "Add" ? "Add" : "Update"}
//                 disabled={!isAddOrUpdateButtonEnabled}
//                 onClick={() => {
//                   setView("status");
//                   addOrUpdateHIDUser();
//                 }}
//               />
//             </div>
//           </>
//         );
//       default:
//         return (
//           <div className="status-container">
//             {status.addUserLoading || status.updateUserLoading ? (
//               <div className="loading">
//                 <Loader variant={LoaderSizes.large} />
//               </div>
//             ) : statusBoolean ? (
//               <>
//                 <Iconography
//                   icon="circleCheck"
//                   size={IconographySizes.XLarge}
//                   theme={IconographyThemes.Success}
//                   className="status-icon"
//                 />
//                 <div className="message">
//                   {mode === "Add"
//                     ? "HID User Added with Invitation Sent"
//                     : "HID User Updated"}
//                 </div>
//                 <div className="user-info" style={{ gap: "8px" }}>
//                   <div className="name">{`${userDetails.firstName} ${userDetails.lastName}`}</div>
//                   <div className="email">{userDetails.email}</div>
//                   <div className="role">{userDetails.role}</div>
//                 </div>
//                 <Button
//                   variant="primary"
//                   label="Close"
//                   onClick={() => setModalOpen(false)}
//                 />
//               </>
//             ) : (
//               <>
//                 <Iconography
//                   icon="circleXmark"
//                   size={IconographySizes.XLarge}
//                   theme={IconographyThemes.Error}
//                   className="status-icon"
//                 />
//                 <div className="message">{statusMessage}</div>
//                 <Button
//                   variant="primary"
//                   label="Close"
//                   onClick={() => setModalOpen(false)}
//                 />
//               </>
//             )}
//           </div>
//         );
//     }
//   };

//   return (
//     <Modal
//       headerText={headerText}
//       width={500}
//       onClose={() => setModalOpen(false)}
//       className="hid-user-form-modal"
//     >
//       <div className="user-form-container">{renderView(view)}</div>
//     </Modal>
//   );
// };

// export default FeatureFormModal;

import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux";
import {
  Modal,
  Button,
  Loader,
  Avatar,
  AvatarSize,
  TextField,
  Dropdown,
  Iconography,
  IconographySizes,
  IconographyThemes,
  LoaderSizes,
  TextArea,
} from "@hid-galaxy-ui/galaxy-react";
import {
  addUserSagaAction,
  updateUserSagaAction,
} from "../../../../../redux/saga/user/saga-actions";
import { UserListType } from "../../../../../redux/slices/user/Types";

import "./FeatureFormModal.scss";
import { Constants } from "../../hid-users/hid-user-form-modal/ConstData";

const HIDSiteOptions = Constants.Site.map((role) => ({
  label: role.label,
  value: role.value,
}));

const HIDTypeOptions = Constants.Type.map((role) => ({
  label: role.label,
  value: role.value,
}));

const HIDStatusOptions = Constants.Status.map((role) => ({
  label: role.label,
  value: role.value,
}));

const HIDPriorityOptions = Constants.Priority.map((role) => ({
  label: role.label,
  value: role.value,
}));

const FeatureFormModal: React.FC<{
  user?: any;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mode: "Add" | "Update";
  onSuccess?: () => void;
}> = ({ user, setModalOpen, mode, onSuccess }) => {
  const [userDetails, setUserDetails] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    site: "",
    type: "",
    status: "",
    priority: "",
    description: "",
  });
  const [view, setView] = React.useState<"detail" | "status">("detail");
  const [emailStatus, setEmailStatus] = React.useState<
    { status: "success" | "error" } | {}
  >({});
  const [errorMsg, setErrorMsg] = React.useState({
    emailMsg: "",
  });
  const [selectedSite, setSelectedSite] = React.useState(null);
  const [selectedType, setSelectedType] = React.useState(null);
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  const [selectedPriority, setSelectedPriority] = React.useState(null);
  const { status } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const headerText =
    view === "status"
      ? ""
      : mode === "Add"
      ? "Add New Feature"
      : "Update Feature";

  React.useEffect(() => {
    if (user) {
      const selectedtype = HIDTypeOptions.find(
        (role) => role.value === user.type
      );
      const selectedsite = HIDSiteOptions.find(
        (role) => role.value === user.site
      );
      const selectedstatus = HIDStatusOptions.find(
        (role) => role.value === user.status
      );
      const selectedpriority = HIDPriorityOptions.find(
        (role) => role.value === user.priority
      );

      setSelectedSite(selectedsite);
      setSelectedType(selectedtype);
      setSelectedStatus(selectedstatus);
      setSelectedPriority(selectedpriority);

      setUserDetails({
        ...userDetails,
        site: user.site,
        type: user.type,
        status: user.status,
        priority: user.priority,
        description: user.description,
      });
    }
  }, [user]);

  React.useEffect(() => {
    if (emailRegex.test(userDetails.email)) {
      setEmailStatus({});
      setErrorMsg({
        ...errorMsg,
        emailMsg: "",
      });
    }
  }, [userDetails.email]);

  const handleChange = (event: React.FormEvent<HTMLInputElement>): void => {
    setUserDetails({
      ...userDetails,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const validateEmail = () => {
    if (!emailRegex.test(userDetails.email)) {
      setEmailStatus({ status: "error" });
      setErrorMsg({
        ...errorMsg,
        emailMsg: "Enter valid email-id",
      });
    }
  };

  const onRoleSelect = (
    data: { label: string; value: string },
    key: string
  ) => {
    let value = data ? data.value : "";

    // Update the selected state based on the key-----------------------
    if (key === "site") {
      setSelectedSite(data);
    } else if (key === "type") {
      setSelectedType(data);
    } else if (key === "status") {
      setSelectedStatus(data);
    } else if (key === "priority") {
      setSelectedPriority(data);
    }

    setUserDetails({
      ...userDetails,
      [key]: value,
    });
  };

  const isAddOrUpdateButtonEnabled =
    userDetails.firstName &&
    userDetails.lastName &&
    emailRegex.test(userDetails.email) &&
    userDetails.role;

  const addOrUpdateHIDUser = () => {
    if (mode === "Add") {
      const featureData = JSON.parse(
        sessionStorage.getItem("feature_details") || "[]"
      );
      console.log("featureData", featureData);
      featureData.push({
        id: featureData.length + 1,
        site: userDetails.site,
        type: userDetails.type,
        status: userDetails.status,
        priority: userDetails.priority,
        description: userDetails.description,
      });
      sessionStorage.setItem("feature_details", JSON.stringify(featureData));
      setModalOpen(false);
      if (onSuccess) onSuccess();
    } else {
      // Update mode-----------------------
      const featureData = JSON.parse(
        sessionStorage.getItem("feature_details") || "[]"
      );
      const updateIndex = featureData.findIndex(
        (data: any) => data.id === user.id
      );

      if (updateIndex !== -1) {
        featureData[updateIndex] = {
          ...featureData[updateIndex],
          site: userDetails.site,
          type: userDetails.type,
          status: userDetails.status,
          priority: userDetails.priority,
          description: userDetails.description,
        };
        sessionStorage.setItem("feature_details", JSON.stringify(featureData));
      }
      setModalOpen(false);
      if (onSuccess) onSuccess();
    }
  };

  const renderView = (view: "detail" | "status") => {
    const statusBoolean =
      mode === "Add" ? status.addUserStatus : status.updateUserStatus;
    const statusMessage =
      mode === "Add" ? status.addUserMessage : "Something went wrong!";
    switch (view) {
      case "detail":
        return (
          <>
            <div className="details-form">
              <Avatar size={AvatarSize.XLarge} isEditable={false} />
              <div className="input-row-wrapper">
                <div className="input-col-wrapper">
                  <div className="label-field-container">
                    <label className="field-label">Site</label>
                    <Dropdown
                      id="role"
                      name="role"
                      placeholder="Select Site"
                      options={HIDSiteOptions}
                      theme="dark"
                      selected={selectedSite}
                      onSelect={(data) => {
                        onRoleSelect(data, "site");
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="input-row-wrapper">
                <div className="input-col-wrapper">
                  <div className="label-field-container">
                    <label className="field-label">Type</label>
                    <Dropdown
                      id="role"
                      name="role"
                      placeholder="Select Type"
                      options={HIDTypeOptions}
                      theme="dark"
                      selected={selectedType}
                      onSelect={(data) => {
                        onRoleSelect(data, "type");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="input-row-wrapper">
                <div className="label-field-container">
                  <label className="field-label">Status</label>
                  <Dropdown
                    id="role"
                    name="role"
                    placeholder="Select Status"
                    options={HIDStatusOptions}
                    theme="dark"
                    selected={selectedStatus}
                    onSelect={(data) => {
                      onRoleSelect(data, "status");
                    }}
                  />
                </div>
              </div>
              <div className="input-row-wrapper">
                <div className="label-field-container">
                  <label className="field-label">Priority</label>
                  <Dropdown
                    id="role"
                    name="role"
                    placeholder="Select Priority"
                    options={HIDPriorityOptions}
                    theme="dark"
                    selected={selectedPriority}
                    onSelect={(data) => {
                      onRoleSelect(data, "priority");
                    }}
                  />
                </div>
              </div>
              <div className="input-row-wrapper">
                <div className="label-field-container">
                  <TextArea
                    label="Description"
                    id="noteText"
                    placeholder=""
                    name="noteText"
                    maxLength={1000}
                    theme="dark"
                    value={userDetails.description}
                    onChange={(e: any) => {
                      setUserDetails({
                        ...userDetails,
                        description: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="button-group">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={() => setModalOpen(false)}
              />
              <Button
                variant="primary"
                label={mode === "Add" ? "Add" : "Update"}
                onClick={() => {
                  // setView("status");
                  addOrUpdateHIDUser();
                }}
              />
            </div>
          </>
        );
      default:
        return (
          <div className="status-container">
            {status.addUserLoading || status.updateUserLoading ? (
              <div className="loading">
                <Loader variant={LoaderSizes.large} />
              </div>
            ) : statusBoolean ? (
              <>
                <Iconography
                  icon="circleCheck"
                  size={IconographySizes.XLarge}
                  theme={IconographyThemes.Success}
                  className="status-icon"
                />
                <div className="message">
                  {mode === "Add"
                    ? "HID User Added with Invitation Sent"
                    : "HID User Updated"}
                </div>
                <div className="user-info" style={{ gap: "8px" }}>
                  <div className="name">{`${userDetails.firstName} ${userDetails.lastName}`}</div>
                  <div className="email">{userDetails.email}</div>
                  <div className="role">{userDetails.role}</div>
                </div>
                <Button
                  variant="primary"
                  label="Close"
                  onClick={() => setModalOpen(false)}
                />
              </>
            ) : (
              <>
                <Iconography
                  icon="circleXmark"
                  size={IconographySizes.XLarge}
                  theme={IconographyThemes.Error}
                  className="status-icon"
                />
                <div className="message">{statusMessage}</div>
                <Button
                  variant="primary"
                  label="Close"
                  onClick={() => setModalOpen(false)}
                />
              </>
            )}
          </div>
        );
    }
  };

  return (
    <Modal
      headerText={headerText}
      width={500}
      onClose={() => setModalOpen(false)}
      className="hid-user-form-modal"
    >
      <div className="user-form-container">{renderView(view)}</div>
    </Modal>
  );
};

export default FeatureFormModal;
